import { Component, Vue } from 'vue-property-decorator'
import { IGeoAddress } from '@immosparrow/cockpit-api-v2'

@Component
export default class GlobalMixin extends Vue {
  displayAddress (address: IGeoAddress | undefined) {
    let addr = ''
    if (address) {
      if (address.street || address.streetNumber) {
        addr = `${address.street}${address.streetNumber != null ? ` ${address.streetNumber}` : ''}, ${address.zip} ${address.locality}${address.stateShort ? `, ${address.stateShort}` : ''}`
      } else if (address.zip || address.locality) {
        addr = `${address.zip} ${address.locality}, ${address.stateShort}`
      }
    }
    return addr
  }

  formatPrice (price: number | undefined, currency?: string | undefined) {
    if (price) {
      let formatedPrice = price.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
      if (currency) {
        formatedPrice = `${currency} ${formatedPrice}`
      }
      return formatedPrice
    }
    return ''
  }

  get id () {
    return this.$route.query?.leadListId as string
  }

  get resourceUrl () {
    return process.env.VUE_APP_RESOURCE_URL
  }

  generateImageUrl (id: string | undefined, width = 500, height = 500) {
    return id ? `${this.resourceUrl}/image/get/${id}/?mw=${width}&mh=${height}&q=100` : ''
  }
}
